import { uuid } from 'utils/uuid'

// eslint-disable-next-line import/prefer-default-export
export const createFingerPrint = () => uuid()

export const FINGER_PRINT_KEY = 'FP'
